import React, { useState } from 'react';
import { Link, useNavigate } from 'react-router-dom';
import { useDarkClasses } from '../../hooks/useDarkClasses';
import { MailIcon, LockIcon, EyeIcon, EyeOffIcon, ArrowRightIcon, BookOpenIcon } from 'lucide-react';
const Login = () => {
  const dk = useDarkClasses();
  const navigate = useNavigate();
  const [showPassword, setShowPassword] = useState(false);
  const [email, setEmail] = useState('');
  const [password, setPassword] = useState('');
  const [isLoading, setIsLoading] = useState(false);
  const handleSubmit = (e: React.FormEvent) => {
    e.preventDefault();
    setIsLoading(true);
    // Simulate login
    setTimeout(() => {
      setIsLoading(false);
      navigate('/dashboard');
    }, 1500);
  };
  return <div className={`min-h-screen flex ${dk.page}`} data-id="element-6801" data-mp="4fpiguvdjxgw">
      {/* Left Panel - Editorial/Brand */}
      <div className="hidden md:flex w-1/2 bg-slate-900 text-white flex-col justify-between p-12 lg:p-16" data-id="element-6802" data-mp="2a862u5bh9zdn">
        <div data-id="element-6803" data-mp="268dthqe9fp78">
          <div className="flex items-center gap-3 mb-2" data-id="element-6804" data-mp="v2ickjkki4mw">
            <BookOpenIcon className="h-8 w-8 text-indigo-400" data-id="element-6805" data-mp="v3tioq1hjoh6" />
            <span className="text-2xl font-bold tracking-tight" data-id="element-6806" data-mp="10121msugjwjh">LitLaunch</span>
          </div>
        </div>

        <div className="max-w-md" data-id="element-6807" data-mp="150ek71eaqhg9">
          <h1 className="text-4xl lg:text-5xl font-bold mb-6 leading-tight" data-id="element-6808" data-mp="14zd9iy16zwz2">
            The home of indie fiction.
          </h1>
          <p className="text-lg text-slate-300 leading-relaxed" data-id="element-6809" data-mp="1eqhpo12ltnvh">
            Discover books, support authors, and connect with a community that
            loves reading as much as you do.
          </p>
        </div>

        <div className="space-y-6" data-id="element-6810" data-mp="1nqnyh9ncxzob">
          <div className="flex items-start gap-4" data-id="element-6811" data-mp="1nsh36jeeu9to">
            <div className="h-10 w-10 rounded-full bg-indigo-500 flex items-center justify-center text-sm font-bold" data-id="element-6812" data-mp="1sq0kjs6en2pu">
              SM
            </div>
            <div data-id="element-6813" data-mp="3pk3pw8r9rikc">
              <p className="text-sm text-slate-300 italic mb-1" data-id="element-6814" data-mp="3pknajx8b0l22">
                "Found my next 10 favourite books in a week. This platform
                changed how I read."
              </p>
              <p className="text-xs font-bold text-indigo-400" data-id="element-6815" data-mp="3mj0kid2fgezd">
                Sarah M., Reader
              </p>
            </div>
          </div>
          <div className="flex items-start gap-4" data-id="element-6816" data-mp="9znb1ljzsfe">
            <div className="h-10 w-10 rounded-full bg-purple-500 flex items-center justify-center text-sm font-bold" data-id="element-6817" data-mp="7mufte9bxnk">
              JD
            </div>
            <div data-id="element-6818" data-mp="99mder8u1bt5">
              <p className="text-sm text-slate-300 italic mb-1" data-id="element-6819" data-mp="9935828zi1sb">
                "Finally, a place where indie authors are the main event, not an
                afterthought."
              </p>
              <p className="text-xs font-bold text-purple-400" data-id="element-6820" data-mp="iyw72bjbr2jd">
                James D., Author
              </p>
            </div>
          </div>
        </div>
      </div>

      {/* Right Panel - Form */}
      <div className={`flex-1 flex items-center justify-center p-8 ${dk.surface}`} data-id="element-6821" data-mp="sz6hxphvzxvd">
        <div className="max-w-sm w-full space-y-8" data-id="element-6822" data-mp="o0vatmiz81gu">
          <div className="text-center md:text-left" data-id="element-6823" data-mp="17ldekbuz0ykv">
            <div className="flex justify-center md:justify-start mb-6 md:hidden" data-id="element-6824" data-mp="17llu6bihahzr">
              <BookOpenIcon className="h-10 w-10 text-indigo-600" data-id="element-6825" data-mp="1ble3wrjlyu6p" />
            </div>
            <h2 className={`text-3xl font-bold ${dk.textHeading}`} data-id="element-6826" data-mp="xnpk7n1a1t38">
              Welcome back
            </h2>
            <p className={`mt-2 text-sm ${dk.textMuted}`} data-id="element-6827" data-mp="12kpn5p2tyfq4">
              Don't have an account?{' '}
              <Link to="/create-reader-account" className="font-medium text-indigo-600 hover:text-indigo-500 transition-colors" data-id="element-6828" data-mp="nwbcirz69mz0">
                Create a new account
              </Link>
            </p>
          </div>

          <form className="mt-8 space-y-6" onSubmit={handleSubmit} data-id="element-6829" data-mp="juzub7imo40u">
            <div className="space-y-5" data-id="element-6830" data-mp="jt58lqzj87vp">
              <div data-id="element-6831" data-mp="4xyzuw91xuyo">
                <label htmlFor="email-address" className={`block text-sm font-medium ${dk.textPrimary} mb-1.5`} data-id="element-6832" data-mp="4zju0krgfbw0">
                  Email address
                </label>
                <div className="relative" data-id="element-6833" data-mp="1d7g43frvm8wa">
                  <div className="absolute inset-y-0 left-0 pl-3 flex items-center pointer-events-none" data-id="element-6834" data-mp="188mn3dddrzrd">
                    <MailIcon className={`h-5 w-5 ${dk.textMuted}`} data-id="element-6835" data-mp="13ho3o4x3iljw" />
                  </div>
                  <input id="email-address" name="email" type="email" autoComplete="email" required value={email} onChange={e => setEmail(e.target.value)} className={`block w-full pl-10 pr-3 py-2.5 border rounded-lg focus:ring-2 focus:ring-indigo-500 focus:border-transparent transition-colors ${dk.input}`} placeholder="you@example.com" data-id="element-6836" data-mp="yjv0lkr3a7nu" />
                </div>
              </div>

              <div data-id="element-6837" data-mp="29yi87vgany14">
                <label htmlFor="password" className={`block text-sm font-medium ${dk.textPrimary} mb-1.5`} data-id="element-6838" data-mp="29y02873ty5g0">
                  Password
                </label>
                <div className="relative" data-id="element-6839" data-mp="2mg2hb6ldsquo">
                  <div className="absolute inset-y-0 left-0 pl-3 flex items-center pointer-events-none" data-id="element-6840" data-mp="2mf152ysmpybd">
                    <LockIcon className={`h-5 w-5 ${dk.textMuted}`} data-id="element-6841" data-mp="2ra6q7ve7j8ye" />
                  </div>
                  <input id="password" name="password" type={showPassword ? 'text' : 'password'} autoComplete="current-password" required value={password} onChange={e => setPassword(e.target.value)} className={`block w-full pl-10 pr-10 py-2.5 border rounded-lg focus:ring-2 focus:ring-indigo-500 focus:border-transparent transition-colors ${dk.input}`} placeholder="••••••••" data-id="element-6842" data-mp="2w9025jduirwg" />
                  <button type="button" className="absolute inset-y-0 right-0 pr-3 flex items-center" onClick={() => setShowPassword(!showPassword)} data-id="element-6843" data-mp="3ou1f6ys8730v">
                    {showPassword ? <EyeOffIcon className={`h-5 w-5 ${dk.textMuted} hover:${dk.textSecondary}`} data-id="element-6844" data-mp="1xub63ppin31j" /> : <EyeIcon className={`h-5 w-5 ${dk.textMuted} hover:${dk.textSecondary}`} data-id="element-6845" data-mp="162lti82wz95m" />}
                  </button>
                </div>
              </div>
            </div>

            <div className="flex items-center justify-between" data-id="element-6846" data-mp="1evyrvpjqz2z3">
              <div className="flex items-center" data-id="element-6847" data-mp="1a3x8zks2qe03">
                <input id="remember-me" name="remember-me" type="checkbox" className="h-4 w-4 text-indigo-600 focus:ring-indigo-500 border-gray-300 rounded" data-id="element-6848" data-mp="1a35q9ajksar8" />
                <label htmlFor="remember-me" className={`ml-2 block text-sm ${dk.textSecondary}`} data-id="element-6849" data-mp="88supn4b25mb">
                  Remember me
                </label>
              </div>

              <div className="text-sm" data-id="element-6850" data-mp="3uhvhvuv79oi7">
                <Link to="/forgot-password" className="font-medium text-indigo-600 hover:text-indigo-500 transition-colors" data-id="element-6851" data-mp="3uepuck27yuol">
                  Forgot password?
                </Link>
              </div>
            </div>

            <button type="submit" disabled={isLoading} className="group relative w-full flex justify-center py-2.5 px-4 border border-transparent text-sm font-semibold rounded-lg text-white bg-indigo-600 hover:bg-indigo-700 focus:outline-none focus:ring-2 focus:ring-offset-2 focus:ring-indigo-500 disabled:opacity-70 disabled:cursor-not-allowed transition-all shadow-sm hover:shadow" data-id="element-6852" data-mp="vyex0jfz50yj">
              {isLoading ? <span className="flex items-center" data-id="element-6853" data-mp="2o1gtc1cnd4ov">
                  <svg className="animate-spin -ml-1 mr-3 h-5 w-5 text-white" xmlns="http://www.w3.org/2000/svg" fill="none" viewBox="0 0 24 24" data-id="element-6854" data-mp="2ny2tazrgh7kl">
                    <circle className="opacity-25" cx="12" cy="12" r="10" stroke="currentColor" strokeWidth="4" data-id="element-6855" data-mp="2a1pjmct5yago"></circle>
                    <path className="opacity-75" fill="currentColor" d="M4 12a8 8 0 018-8V0C5.373 0 0 5.373 0 12h4zm2 5.291A7.962 7.962 0 014 12H0c0 3.042 1.135 5.824 3 7.938l3-2.647z" data-id="element-6856" data-mp="2x0vgorxioz55"></path>
                  </svg>
                  Signing in...
                </span> : <span className="flex items-center" data-id="element-6857" data-mp="3kov7tsyqqrk9">
                  Sign in
                  <ArrowRightIcon className="ml-2 h-4 w-4 group-hover:translate-x-1 transition-transform" data-id="element-6858" data-mp="179whzbhckpkm" />
                </span>}
            </button>

            <div className="mt-6" data-id="element-6859" data-mp="1g7oy2huw8192">
              <div className="relative" data-id="element-6860" data-mp="1gaupw4uwph8h">
                <div className="absolute inset-0 flex items-center" data-id="element-6861" data-mp="1l8cq96uuyo4v">
                  <div className={`w-full border-t ${dk.border}`} data-id="element-6862" data-mp="1l5gsbij0fzgf" />
                </div>
                <div className="relative flex justify-center text-sm" data-id="element-6863" data-mp="1q4tncqk1ccu3">
                  <span className={`px-2 ${dk.surface} ${dk.textMuted}`} data-id="element-6864" data-mp="1v4pq6mgzxy82">
                    Or continue with
                  </span>
                </div>
              </div>

              <div className="mt-6 grid grid-cols-2 gap-3" data-id="element-6865" data-mp="23yknx9fsgmdo">
                <button type="button" className={`w-full inline-flex justify-center py-2.5 px-4 border rounded-lg shadow-sm text-sm font-medium transition-colors ${dk.card} hover:${dk.surfaceMuted}`} data-id="element-6866" data-mp="2405l76thmjf8">
                  <span className="sr-only" data-id="element-6867" data-mp="27bj0vbg0jqop">Sign in with Google</span>
                  <svg className="h-5 w-5" fill="currentColor" viewBox="0 0 24 24" data-id="element-6868" data-mp="2c8t1ln8uroru">
                    <path d="M12.48 10.92v3.28h7.84c-.24 1.84-.853 3.187-1.787 4.133-1.147 1.147-2.933 2.4-6.053 2.4-4.827 0-8.6-3.893-8.6-8.72s3.773-8.72 8.6-8.72c2.6 0 4.507 1.027 5.907 2.347l2.307-2.307C18.747 1.44 16.133 0 12.48 0 5.867 0 .307 5.387.307 12s5.56 12 12.173 12c3.573 0 6.267-1.173 8.373-3.36 2.16-2.16 2.84-5.213 2.84-7.667 0-.76-.053-1.467-.173-2.053H12.48z" data-id="element-6869" data-mp="2g9358t96a33j" />
                  </svg>
                </button>

                <button type="button" className={`w-full inline-flex justify-center py-2.5 px-4 border rounded-lg shadow-sm text-sm font-medium transition-colors ${dk.card} hover:${dk.surfaceMuted}`} data-id="element-6870" data-mp="3408ntg6hz9hj">
                  <span className="sr-only" data-id="element-6871" data-mp="19mr4k5d4kysb">Sign in with Apple</span>
                  <svg className={`h-5 w-5 ${dk.textPrimary}`} fill="currentColor" viewBox="0 0 24 24" data-id="element-6872" data-mp="123zz7uxiwilq">
                    <path d="M12.152 6.896c-.948 0-2.415-1.078-3.96-1.04-2.04.027-3.91 1.183-4.961 3.014-2.117 3.675-.546 9.103 1.519 12.09 1.013 1.454 2.208 3.09 3.792 3.039 1.52-.065 2.09-.987 3.935-.987 1.831 0 2.35.987 3.96.948 1.637-.026 2.676-1.48 3.676-2.948 1.156-1.688 1.636-3.325 1.662-3.415-.039-.013-3.182-1.221-3.22-4.857-.026-3.04 2.48-4.494 2.597-4.559-1.429-2.09-3.623-2.324-4.39-2.376-2-.156-3.675 1.09-4.61 1.09zM15.53 3.83c.843-1.012 1.4-2.427 1.245-3.83-1.207.052-2.662.805-3.532 1.818-.78.896-1.454 2.338-1.273 3.714 1.338.104 2.715-.688 3.56-1.702z" data-id="element-6873" data-mp="scdhdfqojla0" />
                  </svg>
                </button>
              </div>
            </div>
          </form>
        </div>
      </div>
    </div>;
};
export default Login;